import {useEffect, useState} from 'react';

import {isNilOrEmpty} from 'ramda-adjunct';

import {datagridApi} from '@dms/api/core';
import {useLazyDataQuery} from '@dms/shared';

import {LastUpdated} from '../types/LastUpdated';
import {ScheduledDaysPeriod} from '../types/ScheduledDaysPeriod';
import {getGridFiltersFromFiltersState} from '../utils/getGridFiltersFromFiltersState';

export const useKanbanControl = () => {
  const [lastUpdated, setLastUpdated] = useState<LastUpdated | null>(null);
  const [scheduledRentDaysPeriod, setScheduledRentDaysPeriod] =
    useState<ScheduledDaysPeriod | null>(null);
  const [scheduledReturnDaysPeriod, setScheduledReturnDaysPeriod] =
    useState<ScheduledDaysPeriod | null>(null);

  const [
    createDataQuery,
    {
      data: rentalOrderQuery,
      isLoading: isLoadingRentalOrderQuery,
      isError: isLoadingRentalOrderQueryErrored,
      isFetching: isFetchingRentalOrderQuery,
    },
  ] = useLazyDataQuery('rental-order');

  const {
    data: rentalOrders,
    isLoading: isLoadingRentalOrders,
    isError: isLoadingRentalOrdersErrored,
    isFetching: isFetchingRentalOrders,
  } = datagridApi.useGetDataByDataQueryQuery(
    {
      gridCode: 'rental-order',
      dataQueryId: rentalOrderQuery?.dataQueryId!,
      offset: 0,
      limit: 1000,
      body: {
        // empty array means "fetch all columns"
        columns: [],
      },
    },
    {
      skip: isNilOrEmpty(rentalOrderQuery?.dataQueryId),
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    createDataQuery(
      getGridFiltersFromFiltersState({
        lastUpdated,
        scheduledRentDaysPeriod,
        scheduledReturnDaysPeriod,
      })
    );
    // createDataQuery is intentionally omitted
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastUpdated, scheduledRentDaysPeriod, scheduledReturnDaysPeriod]);

  return {
    rentalOrders,
    isLoading:
      isLoadingRentalOrders ||
      isLoadingRentalOrderQuery ||
      isFetchingRentalOrderQuery ||
      isFetchingRentalOrders,
    isError: isLoadingRentalOrdersErrored || isLoadingRentalOrderQueryErrored,
    filters: {
      lastUpdated,
      setLastUpdated,
      scheduledRentDaysPeriod,
      setScheduledRentDaysPeriod,
      scheduledReturnDaysPeriod,
      setScheduledReturnDaysPeriod,
    },
  };
};
